import { useEffect, useRef, useState } from 'react';
import { subscribeToaster } from '../services/toaster';
import './Toaster.css';

export default function ToasterHost() {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    return subscribeToaster((payload) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setToast(payload);
      timerRef.current = setTimeout(() => {
        setToast(null);
        timerRef.current = null;
      }, payload.duration);
    });
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  if (!toast) {
    return null;
  }

  const iconClass =
    toast.variant === 'success'
      ? 'fas fa-check-circle pf-toast__icon'
      : 'fas fa-exclamation-circle pf-toast__icon';

  return (
    <div
      className={`pf-toast pf-toast--${toast.variant}`}
      role="alert"
    >
      <i className={iconClass} aria-hidden={true} />
      <span>{toast.message}</span>
    </div>
  );
}
